import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=557761f8&scoped=true"
import script from "./LogoutButton.vue?vue&type=script&lang=js"
export * from "./LogoutButton.vue?vue&type=script&lang=js"
import style0 from "./LogoutButton.vue?vue&type=style&index=0&id=557761f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557761f8",
  null
  
)

export default component.exports